export enum ResultStatus {
  SUCCESS = 'SUCCESS',
  NO_RESULTS = 'NO_RESULTS',
  FILTER_NOT_FOUND = 'FILTER_NOT_FOUND',
  ERROR = 'ERROR',
  LOADING = 'LOADING',
}
